
import { IDS } from "./pnp-approval.constants";



export const pnpDocumentApprovalState = {
    name: IDS.app_policies_documents_approval,
    redirectTo: IDS.app_policies_documents_approval_listing,
    url: '/approval',
    component: 'tabs'
};

export const pnpDocumentApprovalListingState = {
    name: IDS.app_policies_documents_approval_listing,
    url: '',
    component: 'pnpDocumentApprovalGrid',
    /* @ngInject */
    onEnter: ($ngRedux) => {
        $ngRedux.dispatch({
            type: 'TAB_HIDE',
            id: IDS.app_policies_documents_approval,
            state: [IDS.app_policies_documents_approval_details]
        });
    }
};

export const pnpDocumentApprovalDetailsState = {
    name: IDS.app_policies_documents_approval_details,
    url: '/details?id',
    component: 'pnpApproval'
};
